import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./header.css";
import { FaArrowRight, FaBars, FaPhone } from "react-icons/fa6";
import logoIcon from "../../Assets/Images/dashboardLogo.png";
import { FaRegUserCircle, FaTimes } from "react-icons/fa";

const Header = () => {
  const navigate = useNavigate();
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isHomeInitiallyActive, setIsHomeInitiallyActive] = useState(true);
  const location = useLocation();

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (location.pathname !== "/") {
      setIsHomeInitiallyActive(false);
    }
  }, [location]);

  const isActive = (path) => {
    if (path === "/" && location.pathname === "/" && isHomeInitiallyActive) {
      return true;
    }
    return location.pathname === path;
  };

  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  return (
    <>
      <div className="container">
        <div
          className={`header container  justify-content-between align-items-center ${
            isScrolled ? "scrolled" : ""
          }`}
        >
          <div>
            <a className="navbar-brand" href="/">
              <img src={logoIcon} alt="Logo" className="logo-icon" />
            </a>
          </div>

          <div>
            <ul className="header-menu">
              <li className="header-menu-item">
                <Link
                  className={`nav-link ${isActive("/") ? "active-link" : ""}`}
                  to="/"
                  onClick={toggleNav}
                >
                  Home
                </Link>
              </li>
              <li className="header-menu-item">
                <Link
                  className={`nav-link ${
                    isActive("/about") ? "active-link" : ""
                  }`}
                  to="/about"
                  onClick={toggleNav}
                >
                  About
                </Link>
              </li>
              <li className="header-menu-item">
                <Link
                  className={`nav-link ${
                    isActive("/services") ? "active-link" : ""
                  }`}
                  to="/services"
                  onClick={toggleNav}
                >
                  Services
                </Link>
              </li>
              <li className="header-menu-item dropdown verify-dropdown">
                <Link
                  className={`nav-link dropdown-toggle ${
                    isActive("/verify-certification") ? "active-link" : ""
                  }`}
                  to="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Verify Certification
                </Link>
                <ul className="dropdown-menu">
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/verify-individual-trainee"
                      onClick={toggleNav}
                    >
                      Individual Trainee
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/verify-company-certification"
                      onClick={toggleNav}
                    >
                      Company Certification
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="header-menu-item">
                <Link
                  className={`nav-link ${
                    isActive("/contact") ? "active-link" : ""
                  }`}
                  to="/contact"
                  onClick={toggleNav}
                >
                  Contact
                </Link>
              </li>
              <li>
                <button
                  className="btn btn-outline-light rounded-pill px-4"
                  onClick={() => navigate("/contact")}
                >
                  <FaArrowRight /> Get started
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="mobile-header d-flex justify-content-between align-items-center d-md-none">
        <Link to="/" className="navbar-brand">
          <img src={logoIcon} alt="Logo" className="logo-icon" />
        </Link>
        <button className="menu-toggle-btn" onClick={toggleMenu}>
          {menuOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        <ul>
          <li>
            <Link
              to="/"
              className={isActive("/") ? "active-link" : ""}
              onClick={toggleMenu}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/about"
              className={isActive("/about") ? "active-link" : ""}
              onClick={toggleMenu}
            >
              About
            </Link>
          </li>
          <li>
            <Link
              to="/services"
              className={isActive("/services") ? "active-link" : ""}
              onClick={toggleMenu}
            >
              Services
            </Link>
          </li>
          <li>
            <Link
              to="/verify-certification"
              className={isActive("/verify-certification") ? "active-link" : ""}
              onClick={toggleMenu}
            >
              Verify Certification
            </Link>
          </li>
          <li>
            <Link
              to="/contact"
              className={isActive("/contact") ? "active-link" : ""}
              onClick={toggleMenu}
            >
              Contact
            </Link>
          </li>
          <li>
            <button
              className="btn btn-outline-light rounded-pill px-4"
              onClick={() => {
                navigate("/contact");
                toggleMenu();
              }}
            >
              <FaArrowRight /> Get started
            </button>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Header;
